import { FormProps, FORM_ERROR } from "app/core/components/form/Form"
import { toast } from "app/core/components/hints"
import { IoAirplane } from "@superwall/icons/io5/IoAirplane"
import { z } from "zod"
import ModalOverlay, { OpenCloseRender, OverlayType } from "../components/layout/ModalOverlay"
import { OpenCloseProps } from "../components/layout/types"
import { DialogSubtitle, DialogTitle } from "./components"

const defaultButtonRender = ({ open }) => (
  <button className={`ml-2`} onClick={open}>
    <IoAirplane />
  </button>
)

type OverlayFormProps<S extends z.ZodType<any, any>> = FormProps<S> & {
  title?: string
  overlayTitle?: string | React.ReactNode
  subtitle?: string
  loadingText?: string
  successText?: string
  failureText?: string
  renderButton?: OpenCloseRender
  renderForm: ({}: FormProps<S> & OpenCloseProps) => React.ReactNode
  loadingToast?: boolean
  overlayType?: OverlayType
  includeX?: boolean
  startOpen?: boolean
}

const FormOverlay = <S extends z.ZodType<any, any>>({
  loadingToast = false,
  renderButton = defaultButtonRender,
  renderForm,
  title,
  successText,
  failureText,
  loadingText,
  overlayTitle,
  subtitle,
  onSubmit,
  overlayType,
  includeX = false,
  startOpen,
  ...formProps
}: OverlayFormProps<S>) => {
  return (
    <ModalOverlay
      startOpen={startOpen}
      includeX={includeX}
      overlayType={overlayType}
      renderButton={renderButton}
      render={({ open, close }) => (
        <>
          {overlayType != "inline" ? (
            <>
              <DialogTitle>{overlayTitle || title}</DialogTitle>
              {subtitle ? <DialogSubtitle>{subtitle}</DialogSubtitle> : null}
            </>
          ) : undefined}
          <div
            className="
          h-3"
          >
            {" "}
          </div>
          {renderForm({
            open,
            close,
            onSubmit: async (values, form) => {
              const toastId = loadingToast ? toast.loading(loadingText || "...") : undefined
              try {
                const result = await onSubmit(values, form)
                loadingToast
                  ? toast.success({
                      toastId,
                      content: successText || "Success!",
                    })
                  : null
                if (result && result[FORM_ERROR]) {
                  // Make sure we keep teh form open
                } else {
                  close()
                }
              } catch (error) {
                toast.error({ content: (failureText || "Failure ") + error.message })
              }
            },
            ...formProps,
          })}
        </>
      )}
    />
  )
}

export default FormOverlay
